<div class="nsc-app-footer mat-caption" role="contentinfo">

    
      
  <img attr.aria-label="National Student Clearinghouse" src="/assets/Nsc-Tree-Logo.png" alt="National Student Clearinghouse" tabindex="0" aria-label="National Student Clearinghouse  2300 Dulles Station Blvd. Suite 220  Herndon, VA 20171"
    class="nsc-app-footer__logo--nsc" />
  <div class="spacer_address"></div>
  <br />
  2300 Dulles Station Blvd. Suite 220
  <br />
  Herndon,VA 20171
  <br />

  <nsc-spacer size="sm"></nsc-spacer>

  <a href="https://nschelpcenter.force.com/student/s/contactsupport" rel="noopener" target="_blank" aria-label="Open contact us in a new window">
    Contact Us <mat-icon>open_in_new</mat-icon>
  </a>
  &nbsp;
  <a href="https://www.studentclearinghouse.org/privacy-policy/" rel="noopener" target="_blank" aria-label="Open privacy policy in a new window">
    Privacy Policy <mat-icon>open_in_new</mat-icon>
  </a>
  &nbsp;
  <a href="https://www.studentclearinghouse.org/terms-of-use/"  rel="noopener" target="_blank" aria-label="Open Terms and Conditions of use in a new window">
    Terms & Conditions of Use <mat-icon>open_in_new</mat-icon>
  </a>

  <br />

  &copy;{{ copyrightYear }} <a href="http://www.studentclearinghouse.org/" rel="noopener" target="_blank" aria-label="Open National Student Clearinghouse in a new window">
    National Student Clearinghouse <mat-icon>open_in_new</mat-icon>
  </a>. All Rights Reserved.
</div>



